import React from "react";

function useFormValidation(initialState, validate, authenticate) {
  const [values, setValues] = React.useState(initialState);
  const [errors, setErrors] = React.useState({});
  const [isSubmitting, setSubmitting] = React.useState(false);

  React.useEffect(() => {
    if(isSubmitting){
      const noErrors = Object.keys(errors).length === 0;
      if(noErrors){
        console.log('authenticated', values);
        authenticate()
        setSubmitting(false);
      } else {
        setSubmitting(false);
      }
    }
  }, [errors])  //only run callback when error changes

  function handleChange(event){
    event.persist();  // otherwise you get an error, because timing..
    setValues(previusValues => ({
      ...previusValues,
      [event.target.name]: event.target.value
    }))
  }

  function handleBlur(event){
    const validationErrors = validate(values)
    setErrors(validationErrors);

  }

  function handleSubmit(event){
    event.preventDefault();  //page no reload!
    const validationErrors = validate(values)
    setErrors(validationErrors);
    setSubmitting(true);
    console.log({ values })
  }

  return { handleChange, handleBlur, handleSubmit, values, errors, isSubmitting }

}

export default useFormValidation;
